import script from "./MarketingPortDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingPortDetails.vue?vue&type=script&setup=true&lang=js"

import "./MarketingPortDetails.vue?vue&type=style&index=0&id=62fa0660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fa0660"]])

export default __exports__